import axios from 'axios';
import qs from 'qs';
import $ from 'jquery';

const fetch = require('node-fetch');

class Api {
    postApi(data, action, method) {
        // console.log(data);
        if (!method) {
            method = 'POST';
        }
        let url = "https://webtest-api.editorji.com/" + action
        try {
            if (data['islive']) {
                url = "https://node-api.editorji.com/" + action
            }
        } catch (e) {

        }
        const options = {
            method: method,
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url,
        };
        return axios(options)
    }

    getApi(data, action, method) {
        // console.log(data);
        if (!method) {
            method = 'GET';
        }
        let url = "https://webtest-api.editorji.com/" + action
        try {
            if (data['islive']) {
                url = "https://node.editorji.com/" + action
            }
        } catch (e) {

        }

        const options = {
            method: method,
            data: qs.stringify(data),
            url,
        };
        return axios(options)
    }
    postApi2(data, action) {
        var settings = {
            "async": true,
            "crossDomain": true,
            "url": "https://app-api.editorji.com/live-streaming",
            "method": "POST",
            "headers": {
                "Content-Type": "application/x-www-form-urlencoded",
                "User-Agent": "PostmanRuntime/7.11.0",
                "Accept": "*/*",
                "Cache-Control": "no-cache",
                "Postman-Token": "d557d945-1b84-471d-b828-41edaf3c9c88,fe70d44e-12e7-43fc-8c1b-27fc497886bd",
                "Host": "app-api.editorji.com",
                "accept-encoding": "gzip, deflate",
                "content-length": "274",
                "Connection": "keep-alive",
                "cache-control": "no-cache"
            },
            "data": {
                "accessToken": "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiMTU1MTE4ODAxMDA3OTY2MCIsInVzZXJfZGV2aWNlX2NvZGUiOiI3S1FWNmdha09PaDRtRmhmUXAzYyIsImN1cnJlbnRfZGF0ZSI6IjIwMTktMDItMjYgMTk6MDI6MDAifQ.sk4_Ee2HLYmPtbk_7BsE8iRmpAJ5cqvJC57PU-bLHAWdwUvqb46BlxiVW9YG8ArGMtyTh9Oz9x1pcFv6KQzzzQ",
                "lang": "en"
            }
        }

        $.ajax(settings).done(function (response) {
            console.log(response);
        });
    }

    async postApi3(dataurl, action) {

        console.log(dataurl);
        await fetch('https://node-api.editorji.com/live-streaming', {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: dataurl
        }).then(res => res.json())
            .then((res) => {
                console.log(res)
                return res;
            });
    }
}

export default new Api();